import {
  faTimes,
  faPlus,
  faMagnifyingGlass,
  faClock,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCalendarDays,
  faCircleInfo,
  faCircleCheck,
  faCheck,
  faSpinner,
  faPen,
  faReceipt,
  faFilter,
  faFile as faFileSolid,
  faArrowDown,
  faFileMedical,
  faExclamationTriangle,
  faEllipsis,
  faFilePdf,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';

import { faCircleQuestion, faFile } from '@fortawesome/free-regular-svg-icons';

import { IconType } from './types';

export const getIcon = (type: IconType) => {
  switch (type) {
    case 'close':
      return faTimes;
    case 'plus':
      return faPlus;
    case 'edit':
      return faPen;
    case 'clock':
      return faClock;
    case 'exclamationTriangle':
      return faExclamationTriangle;
    case 'circleInfo':
      return faCircleInfo;
    case 'circleCheck':
      return faCircleCheck;
    case 'search':
      return faMagnifyingGlass;
    case 'chevronDown':
      return faChevronDown;
    case 'chevronLeft':
      return faChevronLeft;
    case 'chevronRight':
      return faChevronRight;
    case 'calendar':
      return faCalendarDays;
    case 'check':
      return faCheck;
    case 'spinner':
      return faSpinner;
    case 'questionCircle':
      return faCircleQuestion;
    case 'receipt':
      return faReceipt;
    case 'file':
      return faFile;
    case 'fileSolid':
      return faFileSolid;
    case 'filter':
      return faFilter;
    case 'arrowDown':
      return faArrowDown;
    case 'filePlus':
      return faFileMedical;
    case 'ellipsis':
      return faEllipsis;
    case 'filePdf':
      return faFilePdf;
    case 'circleCross':
      return faCircleXmark;
  }
};
